import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps';
import TableComponent from '../../../components/table/TableOps';
import ACCESS from '../../../ACCESS';

class Etiquetas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: `etiqueta/filter`, deleteUrl: '', deleteField: '', modUrl: '/Guias/Etiqueta' },
      TableOp.Table('Guias con Etiqueta', [
        { label: 'Guia', id: 'g_folio' },
      ], [
        { id: 'edit', icon: 'edit', 
          access: [ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_CREADAS_POR_EL_USUARIO, 
            ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_SUCURSAL_DEL_USUARIO, ACCESS.SEGUIMIENTO_ETIQUETAS.VER_TODAS_ETIQUETAS] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
          <this.TableRender />
      </div>
    )
  }
}

export default withRouter(Etiquetas)